module.exports = __webpack_public_path__ + "static/media/ico-step5-payment.54137d12.svg";